import { createCacheStore } from '@lib/utils/cache';
import { PatternTemplateService } from 'src/api/PatternTemplateService';

/** Cached PatternTemplateService.getPatternTemplates(departmentId) reads. */
export const patternTemplatesCache = createCacheStore(
    'patternTemplate/patternTemplates',
    PatternTemplateService.getPatternTemplates,
);

/** Drops the cached pattern templates of a department (after mutations). */
export const invalidatePatternTemplates = (departmentId: string): void => {
    patternTemplatesCache.invalidate(departmentId);
};

/** Drops all cached pattern template data (department switch, full clears). */
export const invalidatePatternTemplateData = (): void => {
    patternTemplatesCache.invalidateAll();
};
